import { Typography } from '@mui/material';
import { alpha, styled, Theme } from '@mui/material/styles';

import ReorderIcon from '~/assets/icons/ReorderIcon';
import { QuizColorsMode } from '~/blocks/TestCard/TestCard';
import { SMALL_MARGIN_PX, SMALL_RADIUS_PX, TINY_MARGIN_PX } from '~/theme';

export const createAnswersThemes = (theme: Theme) => ({
  [QuizColorsMode.PostVideo]: {
    regular: theme.palette.common.blockBackground.light,
    selected: theme.palette.common.card.darkAccent,
    selectedSubmitted: theme.palette.common.card.lightAccent,
  },
  [QuizColorsMode.CaseStudy]: {
    regular: theme.palette.common.blueDark,
    selected: theme.palette.common.blockBackground.lightContrast,
    selectedSubmitted: theme.palette.common.blockBackground.lightContrast,
  },
});
export const ItemWrapper = styled('div', {
  shouldForwardProp: (prop) =>
    prop !== 'isWrong' && prop !== 'disabled' && prop !== 'displayResults' && prop !== 'colorsMode',
})<{
  disabled?: boolean;
  isWrong?: boolean;
  displayResults?: boolean;
  colorsMode?: QuizColorsMode;
}>`
  display: flex;
  flex-direction: column;
  padding: 12px ${SMALL_MARGIN_PX};
  background: ${({ theme, colorsMode = QuizColorsMode.PostVideo }) =>
    createAnswersThemes(theme)[colorsMode].regular};
  margin-bottom: ${TINY_MARGIN_PX};
  border-radius: ${SMALL_RADIUS_PX};
  border: 1px solid
    ${({ isWrong, displayResults, theme }) =>
      displayResults
        ? isWrong
          ? theme.palette.common.failedError
          : theme.palette.common.green
        : theme.palette.common.transparent};

  ${({ disabled }) => !disabled && 'cursor: pointer;'}
  &:active {
    ${({ disabled }) => !disabled && 'cursor: grabbing;'}
  }

  &:hover {
    background: ${({ disabled, theme, colorsMode = QuizColorsMode.PostVideo }) =>
      disabled
        ? createAnswersThemes(theme)[colorsMode].regular
        : createAnswersThemes(theme)[colorsMode].selected};
  }

  &:last-child {
    margin-bottom: 0;
  }
`;
export const InfoRow = styled('div')`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const Info = styled('div')`
  display: flex;
  align-items: center;
`;
export const StyledReorderIcon = styled(ReorderIcon)`
  width: 16px;
  height: 16px;
  margin-right: ${SMALL_MARGIN_PX};
`;
export const StyledTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isSmall',
})<{ isSmall?: boolean }>`
  font-size: ${({ isSmall }) => (isSmall ? 14 : 18)}px;
  color: ${({ theme }) => theme.palette.common.white};
`;
export const OrderLabel = styled('div')`
  background: ${({ theme }) => theme.palette.common.card.lighterAccent};
  padding: 6px 8px;
  min-width: 40px;
  min-height: 33px;
  color: ${({ theme }) => alpha(theme.palette.common.white, 0.33)};
  font-size: 14px;
  text-align: center;
  border-radius: 2px;
`;
